import {connect} from 'react-redux';

import {CLIENTS_SCREEN, DASHBOARD_SCREEN} from '/enum/screen.enum';
import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  clientsCountFrontlineById,
  clientsCountGen0ById,
  clientsCountOrgById,
  newClientsCountFrontlineById,
  newClientsCountGen0ById,
  newClientsCountOrgById,
} from '/redux/selector/metric.clients.selector';
import {
  frontlineClientsCount,
  gen0ClientsCount,
  newFrontlineClientsCount,
  newGen0ClientsCount,
  newOrganizationClientsCount,
  organizationClientsCount,
} from '/redux/selector/metric.home.selector';
import {createStructuredScreenSelector, withProps} from '/util/selector.util';

import ClientsOverviewSection from './ClientsOverviewSection';

const withCoachUserId = withProps({coachId: userId});

const SELECTOR_MAP = {
  newClientsCountFrontline: {
    [DASHBOARD_SCREEN]: newFrontlineClientsCount,
    [CLIENTS_SCREEN]: newClientsCountFrontlineById,
  },
  newClientsCountGen0: {
    [DASHBOARD_SCREEN]: newGen0ClientsCount,
    [CLIENTS_SCREEN]: newClientsCountGen0ById,
  },
  newClientsCountOrg: {
    [DASHBOARD_SCREEN]: newOrganizationClientsCount,
    [CLIENTS_SCREEN]: newClientsCountOrgById,
  },
  clientsCountFrontline: {
    [DASHBOARD_SCREEN]: frontlineClientsCount,
    [CLIENTS_SCREEN]: clientsCountFrontlineById,
  },
  clientsCountGen0: {
    [DASHBOARD_SCREEN]: gen0ClientsCount,
    [CLIENTS_SCREEN]: clientsCountGen0ById,
  },
  clientsCountOrg: {
    [DASHBOARD_SCREEN]: organizationClientsCount,
    [CLIENTS_SCREEN]: clientsCountOrgById,
  },
};

export default connect(
  createStructuredScreenSelector({
    selectorMap: SELECTOR_MAP,
    defaultScreenName: CLIENTS_SCREEN,
    otherSelectors: {currentUserCompetency: competencyById},
    effect: withCoachUserId,
  }),
)(ClientsOverviewSection);
